import { RootState } from 'modules'

import { CommentsState } from './duck'

export const selectComments = (state: RootState): CommentsState =>
  state.comments
